import React from 'react';
interface Props {
  title: string;
  description?: string[];
  className?: string;
  style?: React.CSSProperties;
}
export const PcTitle = ({ title, description, className }: Props) => {
  return (
    <div
      className={`flex text-[3.5rem] pb-8 flex-col items-center ${className}`}
    >
      <div className={`text-primary font-700 mb-8 font-tcn`}>{title}</div>
      {description?.map((item, index) => (
        <div key={index} className="text-primary text-base font-400 leading-6">
          {item}
        </div>
      ))}
    </div>
  );
};

export const MobileTitle = ({ title, style }: Props) => {
  return (
    <div
      className="text-xl pb-6 pt-[2.5rem] text-center font-700 text-primary font-tcn"
      style={style}
    >
      {title}
    </div>
  );
};
